import { environment } from './../environments/environment';
import { AppService } from './app.service';
import { Component, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { SocketService } from '@services/webFeeder/socket.service';
import { Constants } from '@utils/constants';
import { LayoutService } from '@services/layout.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { TokenService } from '@services/webFeeder/token.service';
import { LogService } from './core/services/log.service';


@Component({
  selector: 'app-fast-trade',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {

  simpleNotificationsOptions = {
    timeOut: Constants.SIMPLE_NOTIFICATIONS_TIMEOUT,
    showProgressBar: Constants.SIMPLE_NOTIFICATIONS_PROGRESS
  };

  private isWebView: boolean = false;

  @HostListener('mousemove')
  onMouseMove() {
    if (this.configService.isAuthenticadSystem()) {
      this._autoLogoutService.resetTime();
    }
  }

  @HostListener('click')
  onClick() {
    if (this.configService.isAuthenticadSystem()) {
      this._autoLogoutService.resetTime();
    }
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    if (this.isWebView) {
      window.sessionStorage.clear();
    }
  }


  constructor(
    domSanitizer: DomSanitizer,
    public icons: MatIconRegistry,
    private _autoLogoutService: AutoLogoutService,
    private socketService: SocketService,
    private layoutService: LayoutService,
    private renderer: Renderer2,
    private configService: ConfigService,
    private tokenService: TokenService,
    private appService: AppService,
    private logSvc: LogService
  ) {
    icons.addSvgIcon('account', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/account.svg'));
    icons.addSvgIcon('add', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/add.svg'));
    icons.addSvgIcon('alert-octagon', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/alert-octagon.svg'));
    icons.addSvgIcon('apps', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/apps.svg'));
    icons.addSvgIcon('apple-store', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/apple-store.svg'));
    icons.addSvgIcon('arrow-down', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/arrow-down.svg'));
    icons.addSvgIcon('arrow-left', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/arrow-left.svg'));
    icons.addSvgIcon('arrow-right', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/arrow-right.svg'));
    icons.addSvgIcon('arrow-up', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/arrow-up.svg'));
    icons.addSvgIcon('auction_hammer', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/auction_hammer.svg'));
    icons.addSvgIcon('building', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/building.svg'));
    icons.addSvgIcon('cash', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/cash.svg'));
    icons.addSvgIcon('chain', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/chain.svg'));
    icons.addSvgIcon('click', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/click.svg'));
    icons.addSvgIcon('clock', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/clock.svg'));
    icons.addSvgIcon('centralizer-on', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/centralizer-on.svg'));
    icons.addSvgIcon('centralizer-off', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/centralizer-off.svg'));
    icons.addSvgIcon('close', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/close.svg'));
    icons.addSvgIcon('close-btn', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/close-btn.svg'));
    icons.addSvgIcon('corner-up-left', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/corner-up-left.svg'));
    icons.addSvgIcon('coin', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/coin.svg'));
    icons.addSvgIcon('customWk', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/customWk.svg'));
    icons.addSvgIcon('dayTrade', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/dayTrade.svg'));
    icons.addSvgIcon('date', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/date.svg'));
    icons.addSvgIcon('delete', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/delete.svg'));
    icons.addSvgIcon('delete-white', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/delete-white.svg'));
    icons.addSvgIcon('desktop', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/desktop.svg'));
    icons.addSvgIcon('done', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/done.svg'));
    icons.addSvgIcon('download', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/download.svg'));
    icons.addSvgIcon('edit-outline', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/edit-outline.svg'));
    icons.addSvgIcon('edit', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/edit.svg'));
    icons.addSvgIcon('edit-2', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/edit-2.svg'));
    icons.addSvgIcon('erase', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/erase.svg'));
    icons.addSvgIcon('error', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/error.svg'));
    icons.addSvgIcon('event', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/event.svg'));
    icons.addSvgIcon('exclamation-mark', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/exclamation-mark.svg'));
    icons.addSvgIcon('expand', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/expand.svg'));
    icons.addSvgIcon('file', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/file.svg'));
    icons.addSvgIcon('filter', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/filter.svg'));
    icons.addSvgIcon('funds', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/funds.svg'));
    icons.addSvgIcon('goback', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/goback-arrow.svg'));
    icons.addSvgIcon('grid', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/grid.svg'));
    icons.addSvgIcon('google-play', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/google-play.svg'));
    icons.addSvgIcon('help', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/ico-help.svg'));
    icons.addSvgIcon('ico-user-manual', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/ico-user-manual.svg'));
    icons.addSvgIcon('ico-user-manual-outline', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/ico-user-manual-outline.svg'));
    icons.addSvgIcon('ico-user-manual-two', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/ico-user-manual-two.svg'));
    icons.addSvgIcon('ico-warning-octagon', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/ico-warning-octagon.svg'));
    icons.addSvgIcon('icon_firefox', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/icon_firefox.svg'));
    icons.addSvgIcon('icon_chrome', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/icon_chrome.svg'));
    icons.addSvgIcon('icon_opera', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/icon_opera.svg'));
    icons.addSvgIcon('icon_safari', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/icon_safari.svg'));
    icons.addSvgIcon('info-billet', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/info-billet.svg'));
    icons.addSvgIcon('layers', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/layers.svg'));
    icons.addSvgIcon('left-arrow', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/left-arrow.svg'));
    icons.addSvgIcon('lineChart', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/lineChart.svg'));
    icons.addSvgIcon('line-chart-sidebar', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/line-chart-sidebar.svg'));
    icons.addSvgIcon('lock', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/lock.svg'));
    icons.addSvgIcon('lock-outline', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/lock-outline.svg'));
    icons.addSvgIcon('login-lock', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/login-locker.svg'));
    icons.addSvgIcon('logout-outline', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/logout-outline.svg'));
    icons.addSvgIcon('login-transition', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/login-transition.svg'));
    icons.addSvgIcon('logo-cedrotech', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/logo-cedrotech.svg'));
    icons.addSvgIcon('marketSummary', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/marketSummary.svg'));
    icons.addSvgIcon('material-educacional', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/material-educacional.svg'));
    icons.addSvgIcon('monitor', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/monitor.svg'));
    icons.addSvgIcon('monitor-resolution', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/monitor-resolution.svg'));
    icons.addSvgIcon('moon', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/moon.svg'));
    icons.addSvgIcon('moon-outline', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/moon-outline.svg'));
    icons.addSvgIcon('more', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/more.svg'));
    icons.addSvgIcon('news', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/news.svg'));
    icons.addSvgIcon('notify-error', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/notify-error.svg'));
    icons.addSvgIcon('notify-info', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/notify-info.svg'));
    icons.addSvgIcon('notify-success', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/notify-success.svg'));
    icons.addSvgIcon('notify-warning', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/notify-warning.svg'));
    icons.addSvgIcon('no-visibility', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/no-visibility.svg'));
    icons.addSvgIcon('open-lock', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/open-lock.svg'));
    icons.addSvgIcon('padlock-locked', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/padlock-locked.svg'));
    icons.addSvgIcon('padlock-open', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/padlock-open.svg'));
    icons.addSvgIcon('password-success', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/password-success.svg'));
    icons.addSvgIcon('permission', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/permission.svg'));
    icons.addSvgIcon('phone', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/phone.svg'));
    icons.addSvgIcon('power', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/power.svg'));
    icons.addSvgIcon('power-thick', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/power-thick.svg'));
    icons.addSvgIcon('ranking', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/ranking.svg'));
    icons.addSvgIcon('reply', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/reply.svg'));
    icons.addSvgIcon('revert', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/revert.svg'));
    icons.addSvgIcon('saldo', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/saldo.svg'));
    icons.addSvgIcon('send', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/paperplane-colored.svg'));
    icons.addSvgIcon('send', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/send.svg'));
    icons.addSvgIcon('session', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/session.svg'));
    icons.addSvgIcon('success-password', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/ico-success-password.svg'));
    icons.addSvgIcon('success-password-disable', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/ico-success-password-disable.svg'));
    icons.addSvgIcon('term-operator', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/term-operator.svg'));
    icons.addSvgIcon('user', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/user.svg'));
    icons.addSvgIcon('visibility', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/visibility.svg'));
    icons.addSvgIcon('whatsapp-logo', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/whatsapp-logo.svg'));
    icons.addSvgIcon('x-circle', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/x-circle.svg'));
    icons.addSvgIcon('400', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/400.svg'));
    icons.addSvgIcon('403', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/403.svg'));
    icons.addSvgIcon('404', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/404.svg'));
    icons.addSvgIcon('circle-success', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/circle-success.svg'));
    icons.addSvgIcon('file-text', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/file-text.svg'));
    icons.addSvgIcon('writing', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/writing.svg'));
    icons.addSvgIcon('logo-market', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/logo-market.svg'));
    icons.addSvgIcon('user-menu', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/user-menu.svg'));
    icons.addSvgIcon('tools', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/tools.svg'));
    icons.addSvgIcon('money', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/money.svg'));
    icons.addSvgIcon('reports', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/reports.svg'));
    icons.addSvgIcon('reorder', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/reorder.svg'));
    icons.addSvgIcon('reset', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/reset.svg'));
    // Fast Trade Icones 4.0
    icons.addSvgIcon('arrow_call', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/arrow_call.svg'));
    icons.addSvgIcon('arrow-expand', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/arrow-expand.svg'));
    icons.addSvgIcon('book', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/book.svg'));
    icons.addSvgIcon('book-offers', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/book-offers.svg'));
    icons.addSvgIcon('book-history', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/book-history.svg'));
    icons.addSvgIcon('book-extract', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/book-extract.svg'));
    icons.addSvgIcon('currency', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/currency.svg'));
    icons.addSvgIcon('contents', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/contents.svg'));
    icons.addSvgIcon('currency-speed', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/currency-speed.svg'));
    icons.addSvgIcon('currency-trade', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/currency-trade.svg'));
    icons.addSvgIcon('currency-alarm', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/currency-alarm.svg'));
    icons.addSvgIcon('dom', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/dom.svg'));
    icons.addSvgIcon('engine', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/engine.svg'));
    icons.addSvgIcon('graph-bars', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/graph-bars.svg'));
    icons.addSvgIcon('grid-news', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/grid-news.svg'));
    icons.addSvgIcon('graph-pizza', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/graph-pizza.svg'));
    icons.addSvgIcon('login-broker', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/login-broker.svg'));
    icons.addSvgIcon('menu-add', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/menu-add.svg'));
    icons.addSvgIcon('menu-open', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/menu-open.svg'));
    icons.addSvgIcon('menu-open-link', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/menu-open-link.svg'));
    icons.addSvgIcon('order', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/order.svg'));
    icons.addSvgIcon('quote-sheet', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/quote-sheet.svg'));
    icons.addSvgIcon('quote-sumary', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/quote-sumary.svg'));
    icons.addSvgIcon('question', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/question.svg'));
    icons.addSvgIcon('ranking-two', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/ranking-two.svg'));
    icons.addSvgIcon('search', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/search.svg'));
    icons.addSvgIcon('summary', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/summary.svg'));
    icons.addSvgIcon('top-news', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/top-news.svg'));
    icons.addSvgIcon('top-low-trader', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/top-low-trader.svg'));
    icons.addSvgIcon('youtube', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/youtube.svg'));
    icons.addSvgIcon('wallets', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/wallets.svg'));
    icons.addSvgIcon('world', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/world.svg'));
    icons.addSvgIcon('mail', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/mail.svg'));
    icons.addSvgIcon('smartphone', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/smartphone.svg'));
    icons.addSvgIcon('headphone', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/headphone.svg'));
    icons.addSvgIcon('retry', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/retry.svg'));
    icons.addSvgIcon('personal-information', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/personal-information.svg'));
    icons.addSvgIcon('signature-plan', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/signature-plan.svg'));
    icons.addSvgIcon('extra-packages', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/extra-packages.svg'));
    icons.addSvgIcon('success', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/success.svg'));
    icons.addSvgIcon('info', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/info.svg'));
    icons.addSvgIcon('warning', domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/svg/warning.svg'));
  }

  ngOnInit() {
    document.getElementById('spinnerPreLoading')?.remove();

    const location = window.location;
    this.isWebView = this.findGetParameter('wv') == 'true' ? true : false;

    if (location && (location.pathname === '/chart' || location.pathname === environment.BASE_HREF + '/chart') && this.isWebView) {
      window.sessionStorage.clear();
      const tokenWS = this.findGetParameter('token');
      const login_type = this.findGetParameter('login_type') || 's';
      const tkApi = this.findGetParameter('tkapi');
      const userGuid = this.findGetParameter('userguid');
      const isDarkTheme = this.findGetParameter('dark_theme');
      const userIdentifier = this.findGetParameter('user_identifier');
      tokenWS ? login_type.toLowerCase() === 's' ? this.configService.setTokenGraphic(tokenWS) : this.configService.setTokenWS(tokenWS) : null;

      switch (login_type.toLowerCase()) {
        case 's':
          this.configService.setHbLoginTypeEnable('LoginS');
          break;
        case 'w':
          this.configService.setHbLoginTypeEnable('LoginW');
          break;
        case 'o':
          this.configService.setHbLoginTypeEnable('LoginO');
          break;
        case 'a':
          this.configService.setHbLoginTypeEnable('LoginA');
          break;
        default:
          break;
      }

      tkApi ? this.configService.setTokenApi(tkApi) : null;
      userGuid ? this.configService.setGuidUser(userGuid) : null;
      userIdentifier ? this.configService.setUserIdentifier(userIdentifier) : null;

      this.configService.setFavoriteThemeUser(isDarkTheme);
    }
    if (this.configService.isAuthenticadSystem()) {
      this.tokenService.assignServices();
    }

    this.layoutService.isDark$.subscribe(isDark => {
      if (isDark) {
        this.renderer.addClass(document.body, 'darkTheme');
      } else {
        this.renderer.removeClass(document.body, 'darkTheme');
      }
    });
    if (environment.production) {
      this.initGoogleAnalytics(this.configService.getGoogleTagManagerID());
      this.initPrivallyApp(this.configService.getPrivallyPid());
    }
}


  ngOnDestroy() {
    this.socketService.logout();
  }

  findGetParameter(parameterName) {
    var result = null,
      tmp = [];
    location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });
    return result;
  }

  initGoogleAnalytics(googleTagID) {
    if (googleTagID) {
      this.appService.initTagManager(googleTagID);
    }
  }

  initPrivallyApp(privallyPid) {
    if (privallyPid) {
      this.appService.initPrivallyCookie(privallyPid);
    }
  }


}

// @HostListener('window:resize', ['$event'])
//   onResize(event) {
//     if (!this.configService.isNewWindow()) {
//       if (event.target.innerWidth < Constants.MIN_RESOLUTION && !this.resizeModalShown
//         && !AppUtils.getPageByName('/liveUrl()', window.location.href) && !AppUtils.getPageByName('/chatUrl()', window.location.href)) {
//         this.openResolutionModal();
//       } else {
//         if (event.target.innerWidth >= Constants.MIN_RESOLUTION) {
//           this.resizeModalShown = false;
//           if (this.modal !== undefined) {
//             this.modal.close();
//           }
//         }
//       }
//     }
//   }
